export default class Menu {
    constructor() {
        const menu = document.querySelector('[data-behaviour="mobile-menu"]');
        menu.addEventListener('click', (e) => {
            document.body.classList.toggle('is-visible--mobile-menu');
        });

        const header = document.querySelector(
            '[data-behaviour="header-scroll"]',
        );
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                header.classList.add('is-scrolled');
            } else {
                header.classList.remove('is-scrolled');
            }
        });
    }
}
